<div class="child-inventory-form">
  <form #completionForm="ngForm">
    <rms-date name="DateIn" [required]="true" label="Date Created In The Warehouse" [(ngModel)]="DateIn"></rms-date>
    @if(errorMessage){
    <div class="x-sm-font text-red">{{errorMessage}}</div>
    }
  </form>
  <div class="button-container">
    <button mat-button class="btn-bg-green" [disabled]="!completionForm.valid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
